import { render } from "./ListeBonAncien.vue?vue&type=template&id=06f6ca7a&ts=true"
import script from "./ListeBonAncien.vue?vue&type=script&lang=ts"
export * from "./ListeBonAncien.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__